// Dependencies
// toGeoJSON global function available like a static asset 'togeojson.js' on index.html
import _ from 'lodash';

// Utils
import { ascendingAlphabeticalOrder, containsHtmlTags } from '../../shared/utils/data';


const convertToHtmlEmail = (emailStr) =>
  (emailStr && !containsHtmlTags(emailStr))
    ? _.reduce(
      _.split(emailStr, ','),
      (emailList, email) => {
        const cleanEmail = email.trim();
        const separator = emailList ? ', ' : '';

        return `${emailList}${separator}<a href="mailto:${cleanEmail}">${cleanEmail}</a>`;
      },
      ''
    )
    : emailStr;


export const convertKmlDataLayerToJson = (kmlData, userLocation) => {
  const kmlXML = (new DOMParser()).parseFromString(kmlData, 'application/xml');
  const dataLayer = window.toGeoJSON.kml(kmlXML, { styles: true });
  const featureOrderByName = (featureA, featureB) => {
    return ascendingAlphabeticalOrder(featureA.properties.name, featureB.properties.name);
  };
  const featureOrderByDistance = (featureA, featureB) => {
    return ascendingAlphabeticalOrder(featureA.distanceFromUser, featureB.distanceFromUser);
  };
  const aTagRegExp = /<a/;
  const httpRegExp = RegExp('[hH][tT]{2}[pP]://');
  const newFeatures = [];

  dataLayer.features.forEach((feature, index) => {
    const { properties, geometry } = feature;
    const { icon, Website, Email } = properties;

    if (geometry?.type === 'Point' && geometry.coordinates.length === 2
      && geometry.coordinates[0] && geometry.coordinates[1]) {
      const newFeature = {
        ...feature,
        // Assign an id property equals to the index on the array
        id: index.toString(),
        properties: {
          ...properties,
          // Make sure that https:// is being used
          icon: icon ? icon.replace(httpRegExp, 'https://') : icon,
          // Open up the website link on a new tab in the browser
          Website: Website ? Website.replace(aTagRegExp, '<a target="_blank"') : Website,
          Email: convertToHtmlEmail(Email)
        },
        position: { lng: geometry.coordinates[0], lat: geometry.coordinates[1] }
      };

      // Compute the distance from the user location
      if (userLocation) {
        newFeature.distanceFromUser = Number.parseInt(
          window.google.maps.geometry.spherical.computeDistanceBetween(
            new window.google.maps.LatLng(newFeature.position),
            new window.google.maps.LatLng({ lat: userLocation.latitude, lng: userLocation.longitude })
          ), 10
        );
      }

      newFeatures.push(newFeature);
    } else {
      console.log('***data*** Feature w/ invalid coordinates: ', feature); // eslint-disable-line no-console
    }
  });


  dataLayer.features = newFeatures.sort(userLocation ? featureOrderByDistance : featureOrderByName);

  return dataLayer;
};
